import { initHero } from "../components/bem-blocks/hero/hero.js";
import { initWechatModal } from "../components/bem-blocks/wechat-modal/wechat-modal.js";
import { initDeliveryCalculator } from "../components/bem-blocks/self-purchase/self-purchase.js";

const initHaitaoShopLanding = () => {
    const root = document.querySelector("[data-haitao-shop-landing]");
    if (!root) return;

    initHero(root);
    initWechatModal(root);
    initDeliveryCalculator(root);
};

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initHaitaoShopLanding, {
        once: true,
    });
} else {
    initHaitaoShopLanding();
}
